/**
*
* StartConversation
*
*/

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

import { FormattedMessage } from 'react-intl';
import IconButton from 'components/interaction/IconButton/index.jsx';
import messages from '../messages.js';

function StartConversation(props) {
  const { setEditPost } = props;
  const defaultPost = {};
  return (
    <IconButton icon="ss-compose fs-3" variant="link" className="d-print-none" onClick={() => setEditPost(defaultPost)}>
      <FormattedMessage {...messages.startTopic} />
    </IconButton>
  );
}

StartConversation.propTypes = {
  setEditPost: PropTypes.func,
};

export default StartConversation;
